import { render, staticRenderFns } from "../templates/fecondity.pug?vue&type=template&id=1d054f3e&scoped=true&lang=pug&"
import script from "./Fecondity.vue?vue&type=script&lang=js&"
export * from "./Fecondity.vue?vue&type=script&lang=js&"
import style0 from "./Fecondity.vue?vue&type=style&index=0&id=1d054f3e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d054f3e",
  null
  
)

export default component.exports